module.exports = __webpack_public_path__ + "img/dtx-logo-transparent.6b5c9e84.png";